import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';

import {Rest} from "../../Helpers/Rest" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
import PropTypes from 'prop-types';
import Uploads from "../../Components/Uploads/Uploads"
import Form from "../../Components/Form/Form"

var method = "create";
var id = false;
 


export default class FormContainer extends Component {
    
    state = {
        data:{}
    }

    componentDidMount = () => {
        method = this.props.match.params.method
        id = this.props.match.params.id

        if(id){
            var rest = new Rest(this)
            rest.request("galeries", "READ", {id: id}, (res)=>{ 
                this.setState({
                    data: res
                })
            })
        }
    };

    save = () =>{ 
        this.setState({
            errors: false,
            success: false
        })
        var data = this.state.data
        var rest = new Rest(this)
        var rest_method = "CREATE"
        if(method=="edit"){
            rest_method = "UPDATE"
        }
        if(this.state.uploads){
            data['uploads'] = this.state.uploads.map(u=>u.id)
        }
        if(this.state.uploads_galery){
            data['uploads_galery'] = this.state.uploads_galery.map(u=>u.id)
        }
        rest.request("galeries", rest_method, data, (res)=>{ 
             if(!res.errors){
                 this.setState({
                     success: ["Saved"]
                 })
                 setTimeout(()=>{
                     window.location.href = "/galeries/list"
                 }, 500)
             }
        })
    }
    
  render() {
      console.log(this.state)
    return (
        <Container>
            <Row className="mt-3 mb-3">
            <Col>
                <h4>
                    { method==="edit"? "Edit galery" : "Add galery"}
                </h4>
            </Col>
            </Row>

            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
            {
                this.state.success && <InfoBlock data={this.state.success} variant="info" />
            }
            
            <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center">
                    <Col>
                        <Form
                            fields = {
                              [
                                {
                                  name: "name",
                                  label: "Name"
                                }, 
                                {
                                  name: "description",
                                  label: "Description",
                                  as: "html"
                                },
                              ]
                            }
                            store_to={"data"}
                            _this = {this}
                        />

                        <div>
                            { this.state.data.id && method==="edit" && <Uploads
                                label={"Add preview image"}
                                max={1}
                                table_name={"galeries"}
                                record_id={this.state.data.id}
                                variant="preview"
                                base64={true}
                                accept="image/*"
                            />}
                            { method==="create" && <Uploads
                                label={"Add preview image"}
                                max={1}
                                table_name={"galeries"}
                                variant="preview"
                                base64={true}
                                accept="image/*"
                                returnUploads={(uploads)=>this.setState({uploads:uploads})}
                            />}
                        </div> 
                        <hr/>
                        <div>
                            { this.state.data.id && method==="edit" && <Uploads
                                label={"Add galery images"}
                                max={200}
                                table_name={"galeries"}
                                record_id={this.state.data.id}
                                variant= "galery"
                                base64={true}
                                accept="image/*"
                                sortable={true}
                            />}
                            { method==="create" && <Uploads
                                label={"Add galery images"}
                                max={200}
                                table_name={"galeries"}
                                variant= "galery"
                                base64={true}
                                accept="image/*"
                                returnUploads={(uploads)=>this.setState({uploads_galery:uploads})} 
                                sortable={true}
                            />}
                        </div>

                        <Button className="btn-block" variant="dark" onClick={this.save}>
                            Save
                        </Button>
                    </Col>
                </Row> 
            </Col>
        </Row>

        </Container>
    );
  }
}



FormContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
            method: PropTypes.string
        })
    }), 
}